// extracted by mini-css-extract-plugin
module.exports = {"input":"Subjects_input__3_kJw","subjects":"Subjects_subjects__3N-mi"};